import { NAME } from './constants';
import { router } from './router';

export const ServiceJobSplitBilling = {
	name: NAME,
	router,
};
